import img3 from './../../images/img3.jpg'; 
import img4 from './../../images/img4.jpg'; 
import img5 from './../../images/img5.jpg'; 
import img6 from './../../images/img6.jpg'; 
import img7 from './../../images/img7.jpg'; 
import img8 from './../../images/img8.jpg'; 
import img9 from './../../images/img9.jpg'; 
import img10 from './../../images/img10.jpg'; 
import img11 from './../../images/img11.jpg'; 


const images = [
    {
        id: 2,
        href: img3,
        alt: 'orange tabby cat',
        date: '7-30-2023',
        title: 'Mango',
        description: 'Mango outside',
    },
    {
        id: 3,
        href:img4,
        alt: 'siamese tabby cat',
        date: '7-21-2023',
        title: 'Koori',
        description: 'Koori under the avocado tree',        
    },
    {
        id: 4,
        href:img5,
        alt: 'orange tabby cat',
        date: '7-21-2023',
        title: 'Mango',
        description: "Mango by the lemon tree",
    },
    {
        id: 5,
        href:img6,
        alt: 'orange tabby cat',
        date: '7-21-2023',
        title: 'Mango',
        description: 'Mango laying in the shade',
    },
    {
        id: 6,
        href: img7,
        alt: 'orange tabby cat',
        date: '7-21-2023',
        title: 'Mango',
        description: 'Mango laying on brick',
    },
    {
        id: 7,
        href: img8,
        alt: 'orange tabby cat and siamese tabby cat',
        date: '7-21-2023',
        title: 'Koori and Mango',
        description: "Koori and Mango looking at each other through the window",
    },
    {
        id: 8,
        href:img9,
        alt: 'siamese tabby cat',
        date: '7-20-2023',
        title: 'Koori',
        description: 'Koori in car',
    },
    {
        id: 9,
        href: img10,
        alt: 'orange tabby cat and siamese tabby cat',
        date: '6-16-2023',
        title: 'Mango',
        description: 'mango and koori on window sill perch',
    },
    {
        id: 10,
        href: img11,
        alt: 'siamese tabby cat',
        date: '8-6-2023',
        title: 'Koori',
        description: 'Koori in bathtub',
        
    },
];
export default images;
